export const ONE = '1';
export const TWO = '2';
export const THREE = '3';
export const FOUR = '4';
export const DECIMAL_ONE = '11';
export const DECIMAL_TWO = '12';
export const DECIMAL_THREE = '13';
export const DECIMAL_FOUR = '14';
